import * as React from 'react';

import { TOfferGeo } from '../../../types/offer';
import { isPrimaryMetroRegion } from '../../AddressContainer/helpers';

export const useUnderground = (geo?: TOfferGeo | null) => {
  const underground = React.useMemo(() => {
    if (!geo) {
      return undefined;
    }
    if (geo.undergrounds && isPrimaryMetroRegion(geo)) {
      const offerUndergrounds = geo.undergrounds
        .concat()
        .sort(({ time: timeA }, { time: timeB }) => (timeA ?? 0) - (timeB ?? 0));

      return offerUndergrounds.find(underground => underground.isDefault) || offerUndergrounds[0];
    }

    return undefined;
  }, [geo]);

  return underground;
};
